import { render } from "./SettingSetupComponent.vue?vue&type=template&id=14c91fcb&scoped=true"
import script from "./SettingSetupComponent.vue?vue&type=script&lang=js"
export * from "./SettingSetupComponent.vue?vue&type=script&lang=js"

import "./SettingSetupComponent.vue?vue&type=style&index=0&id=14c91fcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c91fcb"]])

export default __exports__